import { t } from '../i18n';
import { normalizeNoteTheme } from './noteTheme';

export const noteText = (key, replacements) => t(`notesUnified.${key}`, undefined, replacements);

export function normalizeNote(note = {}, kind = 'personal') {
  const sourceType = note.sourceType || (note.sourcePresetId ? 'preset' : note.sourceMarketListingId ? 'market' : kind === 'personal' ? 'custom' : kind);
  const cards = (Array.isArray(note.cards) ? note.cards : note.preview || []).map((card, index) => ({
    ...card,
    id: card.id || `preview-${index}`,
    readingTitle: card.readingTitle || (card.cardType === 'reading' ? card.title : undefined),
    front: card.front || card.readingTitle || card.title || '',
  }));
  return {
    ...note,
    id: note.noteId || note.id,
    title: note.noteTitle || note.title || '',
    description: note.description || '',
    difficulty: note.difficulty || null,
    sourceType,
    authorNickname: note.authorNickname || (sourceType === 'preset' ? noteText('officialAuthor') : noteText('unknownAuthor')),
    questionLocale: note.questionLocale || (kind === 'personal' ? 'ko-KR' : ''),
    learningLocale: note.learningLocale || note.learningLanguage || (kind === 'personal' ? 'en-US' : ''),
    cardCount: note.cardCount ?? cards.length,
    ...normalizeNoteTheme(note),
    cards,
  };
}
